import { api } from "../api";

/**
 * driverFindAllListResponse - Function that finds on database all drivers as select list   
 *`/drivers/list 
 * method GET 
 * @async-function
 */
const driverFindAllListResponse = async (token: string, customerId: number, departmentId: number, ignoreDepartments: boolean = false) => {
    const response = await api.get(
        `/drivers/list/${customerId}/${departmentId}?ignoreDepartments=${ignoreDepartments}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};
export default driverFindAllListResponse;